import React, { useState, useEffect } from 'react';

import { Mensaje } from '../../mensajes';

import { Dimmer } from "../../spinner";

 
import useTable from "../../useTable";
import { ModalECA } from './modalEstadoCuentaApuestas';

function TablaApuestasEstado() {
    
    const headCells = [
        { id: 'idcomercio', label: 'CODIGO', width: '10px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'ritm', label: 'RITM', width: '80px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'rif', label: 'RIF', width: '80px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'nombre', label: 'NOMBRE', width: '300px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'reprelegal', label: 'CEDULA RESPONSABLE', width: '150px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
        { id: 'accion', label: 'OPCIONES', width: '180px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },
    ]

    /* variables de estado */
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [mostrar5, setMostrar5] = useState(false);
    const [contar, setContar] = useState(0);
    const [contar2, setContar2] = useState(0);
    const [contar4, setContar4] = useState(0);
    const [contar6, setContar6] = useState(0);
    const [contarRet, setContarRet] = useState(0);
    const [activate, setActivate] = useState(false);
    const [operacion, setOperacion] = useState(0);
    const [comercio, setComercio] = useState();
    const [persona, setPersona] = useState();
    const [statusCome, setStatusCome] = useState();
    const [usuariow, setUsuariow] = useState();
    const [idUsuario, setIdUsuario] = useState();
    const [retencion, setRetencion] = useState();
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [anioActu, setAnioActu] = useState(localStorage.getItem('anioactu'));
    const [ipMac, setIpMac] = useState({ip:localStorage.getItem('ip'), mac:localStorage.getItem('mac')});
    const [deshabilitado, setDeshabilitado] = useState(false);
    const [permiso, setPermiso] = useState();
    const [horaope, setHoraope] = useState();
    const [declaWeb, setDeclaWeb] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } });
    const [mostarModal, setMostrarModal] = useState(false);

    const abrirContri = () => {
        setMostrarModal(true);
    }

    const cerrarContri = () => {
        setMostrarModal(false);
    }

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    /* metodo para filtrar la tabla */
    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.idagenteretencion.includes(target.value)
                            || x.ritm.toLowerCase().includes(target.value.toLowerCase())
                            || x.rif.toLowerCase().includes(target.value.toLowerCase())
                            || x.nombre.toLowerCase().includes(target.value.toLowerCase())
                            || x.reprelegal.includes(target.value)) {
                            return x;
                        }
                    });
                }
            }
        })

    };

  
    const handleCloseMensa = () => {
        setMostrar(false);
    }


    /* metodo para cargar todos los agentes */

    const seleccionarComercios = () => {
        setContar4(0);
        setContar(0);
        setActivate(true);
    };


    const seleccionarStatus = () => {
        setContar2(0);
        setContar(0);

    };


    /* metodo para cargar la configuracion de la industria (alcaldia) */

    const seleccionarConfiguracion = () => {
        setContar(0);
    }; 
 

    /* metodo para cargar el usuarioweb asociado al agente si tiene declaracion web */

    /* const seleccionarUsuarioWeb = (idC) => {
        SelectUsuarioWeb({variables: { idcomercio: idC }});
    }; */


    /* metodo para cargar el historico de retencion si tiene declaracion web */

    /* const seleccionarRetenciones = (idC) => {
        setContarRet(0);
        SelectReten({
            variables: {
                idcomer: idC,
            }
        });
    }; */


    /* metodo para abrir el modal y agregar un nuevo agente */

    /* const agregarComercio = () => {
        setOperacion(1);
        setComercio();
        setUsuariow();
        setPersona();
        setDeshabilitado(false);
        setMostrar5(true);
    };
 */

/* metodo para abrir el modal y consultar un agente */

    /* const consultarComercio = (item, index) => (event) => {
        event.preventDefault();
        setDeshabilitado(true);
        setOperacion(4);
        setContar(0);
        setContar6(0);
        setActivate(true);
        setComercio(item);
        SelectPersona({
            variables: {
                cedula: item.reprelegal
            }
        });

        if(declaWeb){
            seleccionarRetenciones(item.idagenteretencion);
            seleccionarUsuarioWeb(item.idagenteretencion);
        }

    }; */


    /* metodo para abrir el modal y modificar un agente */

   const editarComercio = (item, index) => (event) => {
 
        event.preventDefault();
        setMostrar5('true')
    };


    /* metodo para abrir el modal y eliminar un agente */

    /* const eliminarComercio = (item, index) => (event) => {

        event.preventDefault();
        setDeshabilitado(true);
        setOperacion(3);
        setContar(0);
        setContar6(0);
        setActivate(true);
        setComercio(item);
        SelectPersona({
            variables: {
                cedula: item.reprelegal
            }
        });
        if(declaWeb){
            seleccionarRetenciones(item.idagenteretencion);
            seleccionarUsuarioWeb(item.idagenteretencion);
        }
    };

    const validarActuComercio = () => {

        if (operacion === 4) {
            setComercio();
            setMostrar5(false);
            return;
        }

        setComercio();
        setUsuariow();
        setPersona();
        setMostrar5(false);
        renderizar();
        
    }*/

    const cerrarModalActualizar = () => {

        
        setMostrar5(false);

    } 

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setPermiso(JSON.parse(localStorage.getItem('permisos')).acccontribuyente);
        setIdUsuario(obj.idusuario);
        setEspiritu(obj.espiritu);
        setHoraope(obj.horaope);
        seleccionarStatus();
        seleccionarComercios();
        seleccionarConfiguracion();


    }, []);

    /* useEffect(() => {


        if (contar6 === 0) {
            if (dataPer  && dataConf && datosStatu) {
                
                if(declaWeb){

                    if(dataRet  && dataU){
                        setMostrar5(true);
                        setContar6(contar6 + 1);
                        setActivate(false);
                    }

                }else{

                    setMostrar5(true);
                    setContar6(contar6 + 1);
                    setActivate(false); 
                }

                
            }
        }

        if (contar === 0) {
            if (errorPer) {
                setActivate(false);
                let obj = JSON.parse(JSON.stringify(errorPer));

                setTitulo("Error");
                setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
                setMostrar(true);
                setContar(contar + 1);
            }
        }

        if (contar === 0) {
        
        }

        if (contar === 0) {
            if (errorU) {
                setActivate(false);
                let obj = JSON.parse(JSON.stringify(errorU));
                setTitulo("Error");
                setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
                setMostrar(true);
                setContar(contar + 1);
            }
        }

        

        if (contar === 0) {
            if (errorStatu) {

                let obj = JSON.parse(JSON.stringify(errorStatu));

                setTitulo("Error");
                setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
                setMostrar(true);
                setContar(contar + 1);
            }
        }

        if (contar === 0) {
            if (errorConf) {

                let obj = JSON.parse(JSON.stringify(errorConf));

                setTitulo("Error");
                setMsg(obj.message.replace('GraphQL error: ', '').replace('Network error: ', ''));
                setMostrar(true);
                setContar(contar + 1);
            }
        }
        
        if (contar2 === 0) {
            if (datosStatu) {

                var come = [];

                for (let i = 0; i < datosStatu.allStatuses.nodes.length; i++) {
                    if (datosStatu.allStatuses.nodes[i].tipostatus.trim() === 'COMERCIO') {
                        come.push({
                            idstatus: datosStatu.allStatuses.nodes[i].idstatus,
                            descripcion: datosStatu.allStatuses.nodes[i].descripcion
                        });
                    }

                }

                setStatusCome(come);
                setContar2(contar2 + 1);
            }
        }

    }); */


    return (
        <div className="card">
            <ModalECA
                show={mostarModal} 
                onHideCancela={cerrarContri}
               
            />
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>

            {/* /.card-header */}
            <div className="card-body">
                <div className="content" >
                    <div className="container">

                        <div className="row">
                            <div className="col-md-12" style={{ marginBottom: "10px" }}>
                                <div className="row">
                                    <div className="col-md-3">
                                        <input className="search-input form-control mr-sm-2" style={{ border: '1px solid #007bff' }} type="search" placeholder="Buscar" onChange={handleSearch} aria-label="Search" />
                                    </div>
                                    <div className="col-md-6"></div>
                                    <div className="col-md-3">
                                        <button disabled={permiso && permiso.substring(1, 2) !== "1"} /* onClick={agregarComercio} */ style={{ marginBottom: "10px" }} onClick={abrirContri} className="btn col-md-12 btn-outline-primary"><i className="fas fa-plus"> Agregar Apuesta</i> </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12" style={{ margin: "auto" }} >
                                <TblContainer >
                                    <TblHead />

                                    <tbody>
                                        {

                                            records && recordsAfterPagingAndSorting().map((item, index) => (
                                                <tr key={item.idagenteretencion} style={{ padding: "0" }}>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "10px" }}>{item.idagenteretencion}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.ritm}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.rif}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "left", border: "rgb(14, 101, 238) 1px solid", width: "300px" }}>{item.nombre}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "80px" }}>{item.reprelegal}</td>
                                                    <td style={{ fontSize: "10px", textAlign: "center", border: "rgb(14, 101, 238) 1px solid", width: "180px", padding: 0 }}>
                                                        <button style={{ width: "40px", pointerEvents: permiso && permiso.substring(0, 1) !== "1" ? 'none' : '' }} /* onClick={consultarComercio(item, index)}  */className="btn btn-outline-info"><i className="fas fa-search"></i> </button>
                                                        <a> &nbsp; </a>
                                                        <button style={{ width: "40px", pointerEvents: permiso && permiso.substring(2, 3) !== "1" ? 'none' : '' }} onClick={editarComercio(item, index)} className="btn  btn-outline-success"><i className="fa fa-edit"></i> </button>
                                                        <a> &nbsp; </a>
                                                        <button style={{ width: "40px", pointerEvents: permiso && permiso.substring(3, 4) !== "1" ? 'none' : '' }} /* onClick={eliminarComercio(item, index)} */ className="btn  btn-outline-danger"><i className="fa fa-trash-alt"></i> </button>
                                                    </td>
                                                </tr>

                                            ))
                                        }
                                    </tbody>

                                </TblContainer>
                                <TblPagination />

                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">



                </div>
            </div>

        </div>

    );

}

export default TablaApuestasEstado;
